import { useEffect, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spinner, StateBlock } from '@w7/ui'
import { useStaffMe } from '@/api/hooks/shared/useStaffMe'
import {
  clearPostLoginFalldown,
  consumePostLoginFalldown,
  logout,
} from '@/auth/oidc'
import { NAV } from './nav'
import { canAccessUiPath, firstAccessiblePath, isStaffCaller } from './staffAccess'

/** Staff deep-link / nav miss — show message then OIDC logout. */
function StaffUnauthorisedLogout() {
  useEffect(() => {
    logout({ reason: 'unauthorised', silent: true })
  }, [])
  return <StateBlock icon="info" title="Unauthorised Access!" />
}

export function StaffGrantGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const me = useStaffMe()
  if (me.isLoading) {
    return (
      <div className="w7-auth w7-auth-center">
        <Spinner size={22} />
      </div>
    )
  }
  if (!canAccessUiPath(me.data, location.pathname)) {
    if (isStaffCaller(me.data)) {
      // Only the first landing after login falls down; later denials still logout.
      if (consumePostLoginFalldown()) {
        const to = firstAccessiblePath(me.data, NAV)
        if (to !== location.pathname && canAccessUiPath(me.data, to)) {
          return <Navigate to={to} replace />
        }
      }
      return <StaffUnauthorisedLogout />
    }
    // Avoid / → /net-exposure bounce when staff lack books.view.
    return <Navigate to="/overview" replace />
  }
  clearPostLoginFalldown()
  return <>{children}</>
}
